import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { EmpInfo } from '../model/emp.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { TeamInfo } from '../model/team.model';
import { RoleInfo } from '../model/role.model';
import { GlobalService } from '../service/global.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { async } from '@angular/core/testing';
import { strict } from 'assert';
import { data } from 'jquery';
import { SaletrackingInfo } from '../model/saletracking.model';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-role-management',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.css']
})
export class RoleManagementComponent implements OnInit {

  form: FormGroup;
  public body: string;
  RoleListPromise: Promise<RoleInfo[]>
  RoleList: RoleInfo[]
  RoleListPromisereturn: Promise<RoleInfo[]>[]
  CategoryList: LookupInfo[]
  StatusList: LookupInfo[]
  ProjectSaleTypeList: LookupInfo[]
  ProjectSalePhaseList: LookupInfo[]
  ProjectSaleCustomerTypeList: LookupInfo[]
  EmployeeList: EmpInfo[]
  empList: EmpInfo[]
  empListLoad: EmpInfo[]
  empListPromise: Promise<EmpInfo[]>
  empListPromiseReturn: Promise<EmpInfo[]>
  saleOrganizationList: SaleOrganizationInfo[]
  saleOrganizationPromise: Promise<SaleOrganizationInfo[]>
  saleOrganizationMaxList: SaleOrganizationInfo[]

  // array control
  itemsSupport: FormArray;

  flagduplicate: boolean;
  hidProjectSaleId: number

  // Zone pagination variable
  public indexNo: number = 0
  public currentPageNumber: number
  public totalPages: number
  public environment: number

  public empcodeinit: string
  _EmpCode: string;
  //_EmpName: string;
  hidebutton: Boolean;
  assignflag: boolean;
  viewflag: boolean;
  saleorglevelmax: number;
  saleorglevelemplogin: number;

  public currentPageNumberEmp: number
  public totalPagesEmp: number
  ProjectTotal: any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  public totalActive: number
  public totalInActive: number
  public totalHold: number
  public totalClosed: number

  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;

  baseurl: string;

  getreturn: Promise<string>;
  monthNameslist: any;
  yearlist: any[];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSize;
    this.empcodeinit = localStorage.getItem("EmpCode");
    this._EmpCode = localStorage.getItem("EmpCode");
    //this._EmpName = localStorage.getItem("EmpName_TH");
    this.currentPageNumberEmp = 1;
    this.form = this.formBuilder.group({
      RoleNameSearch: [null],
      ProjectSaleCompanyIdSearch: [null],
      RoleStatusSearch: [null],
      ProjectGroupMapping: [null],
      RoleCode: [null],
      RoleName: [null],
      ProjectSaleCompanyId: [null],
      RoleStatus: [null],
      CreateBy: localStorage.getItem("EmpName_TH"),
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      EmpCodeSearch: [null],
      EmpNameSearch: [null],
      FlagAssignSaleTeam: [null]
    });

    this.Clearinput();
    this.loadLookup('ROLESTATUS').then((data) => {
      this.StatusList = data;
    });
    this.LoadSaleOrganizationLevel();
    this.LoadListProjectGroup();
    this.LoadCountProjectGroup();
  }

  btnClick_SearchProjectSaleList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;
    this.LoadProjectSale()
  }
  Clearinput() {
    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var year = d.getFullYear();

    this.form.patchValue({
      RoleCode: null,
      RoleName: null,
      RoleStatus: "1",
      CreateBy: localStorage.getItem("EmpCode") + " - " + localStorage.getItem("EmpName_TH"),
      FlagAssignSaleTeam: "N"
    });
  }

  createItemSupportTeamName(value = ''): FormGroup {
    return this.formBuilder.group({
      SupporTeamName: [value],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );

  }

  ClearSearch() {
    this.form.patchValue({
      RoleNameSearch: "",
      ProjectSaleCompanyIdSearch: "",
      RoleStatusSearch: "",
    });
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.LoadProjectSale();
  }

  LoadProjectSale(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleUpdatePagination(traget);
    }

    this.LoadProjectSaleList();
    this.LoadProjectSaleCountList();
  }

  async LoadProjectSaleList() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.environment;

      var objectjson = {};
      objectjson['RoleName'] = this.checkUndefinedString(this.form.controls['RoleNameSearch'].value);
      objectjson['RoleStatus'] = this.checkUndefinedString(this.form.controls['RoleStatusSearch'].value) != "" ? this.checkUndefinedString(this.form.controls['RoleStatusSearch'].value) : null;
      objectjson['rowFetch'] = this.environment;
      objectjson['rowOFFSet'] = offset;
      objectjson['CreateBy'] = this.checkUndefinedString(this.empcodeinit);
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/GetRole", strjson, httpOptions)
        .toPromise().then((data) => {
          
          this.RoleList = data

        })
    }

  }

  async LoadProjectSaleCountList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['RoleName'] = this.checkUndefinedString(this.form.controls['RoleNameSearch'].value);
      objectjson['CreateBy'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value);

      if (this.viewflag == true) {
      }
      else {
        objectjson['CreateBy'] = this.checkUndefinedString(this.empcodeinit);
      }
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/GetRole", strjson, httpOptions)
        .toPromise().then((data) => {
          this.hidcouchk = data.length;
          if (this.hidcouchk == 0) {
            this.currentPageNumber = 0;
            this.totalPages = 0;
          } else {
            this.totalPages = Math.ceil(this.hidcouchk / this.environment);
          }

        })
    }
  }

  async btnClick_submitInsertProjectSale() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      /*console.log(this.form);*/
      if (this.form.valid) {
        console.log('form submitted');
        this.OnCreating('y');

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['RoleCode'] = this.checkUndefinedString(this.form.controls['RoleCode'].value);
        objectjson['RoleName'] = this.checkUndefinedString(this.form.controls['RoleName'].value);
        objectjson['RoleStatus'] = this.checkUndefinedString(this.form.controls['RoleStatus'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['RoleStatus'].value)) : 0;
        objectjson['CreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['FlagDelete'] = "N";
        objectjson['FlagAssignSaleTeam'] = this.form.controls['FlagAssignSaleTeam'].value === true ? "Y" : "N";

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/InsertRole", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.OnCreating('n');
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');
              $('#ModalCreateComplate').modal();
              this.currentPageNumber = 1;
              this.indexNo = 0;
              this.LoadProjectSale();
            }
          )

      } else {
        this.GlobalService.validateAllFormFields(this.form);
      }
    }
  }

  btnClick_onUpdateProjectSale(id) {
    $('#ModalProjectSale').modal('hide');
    //this.Clearinput();
    this.isOnUpdate = true

    let index = this.RoleList.findIndex(x => x.RoleId == id);


    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var yearcurrent = d.getFullYear();

    console.log(this.RoleList)

    this.form.patchValue({
      RoleCode: this.RoleList[index].RoleCode != null ? this.RoleList[index].RoleCode : null,
      RoleName: this.RoleList[index].RoleName != null ? this.RoleList[index].RoleName : null,
      RoleStatus: this.RoleList[index].RoleStatus != null ? this.RoleList[index].RoleStatus : null,
      FlagAssignSaleTeam: this.RoleList[index].FlagAssignSaleTeam != null ? (this.RoleList[index].FlagAssignSaleTeam == "Y" ? true : false) : null,
    });
    this.hidProjectSaleId = this.RoleList[index].RoleId
    $('#ModalProjectSale').modal();
  }

  async btnClick_submitUpdateProjectSale(id) {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnUpdating('y');
        id = this.hidProjectSaleId
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['RoleId'] = id;
        objectjson['RoleCode'] = this.checkUndefinedString(this.form.controls['RoleCode'].value);
        objectjson['RoleName'] = this.checkUndefinedString(this.form.controls['RoleName'].value);
        objectjson['RoleStatus'] = this.checkUndefinedString(this.form.controls['RoleStatus'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['RoleStatus'].value)) : 0;
        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['FlagAssignSaleTeam'] = this.form.controls['FlagAssignSaleTeam'].value === true ? "Y" : "N";

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/UpdateRole", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.OnUpdating('n');
          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.OnUpdating('n');
              $('#ModalUpdateComplate').modal();

              this.LoadProjectSale();

            }
          )
      }
    } else {
      this.GlobalService.validateAllFormFields(this.form);
    }
  }

  btnClick_deleteProjectSale(auth_token,id): Observable<RoleInfo[]> {
  
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['RoleId'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/DeleteRole", strjsonCusInfo, httpOptions);
    
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectSale"]').prop('checked', check);

  }

  async btnClick_deleteProjectSaleitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteProjectSale(auth_token,parseInt(id)).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalDeleteComplate').modal('show');
              this.LoadProjectSale();
            }
          );
      }
    }

  }

  //Delete แบบ list
  async btnClick_onDeleteProjectSaleList() {

    if (confirm("Are you sure you want to delete this Project?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

        let num = checkkedProjectSale.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
          observableBatch.push(this.btnClick_deleteProjectSale(auth_token,parseInt(ProjectSalecurrent.value)).toPromise().then(val => {
          }));
        }

        Promise.all(observableBatch).then(val => {

          this.SendListIdToDelete(observableBatch);

        });
      }
    }
  }
  async SendListIdToDelete(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectGroupInfo[]>(this.baseurl + "Master/DeleteListProjectGroup", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();
          }
        );
    }
  }

  btnClick_onCreateProjectSale() {
    this.form.reset();
    $('#ModalProjectSale').modal('show');
    this.Clearinput();
    this.isOnUpdate = false

  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  async loadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitProjectSale").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }
  }

  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      $("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      $("#btnsubmitProjectSale").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }
  }

  displayhyperlink(projectcode: string, projectsaleid: number) {
    var body = ""
    body += " <a href=\"/saletracking-management?ProjectSaleID=" + projectsaleid + "\">" + projectcode + "</a>"

    return body;
  }

  LoadSaleOrganizationLevel() {

    this.LoadSaleOrganizationLevelList().then(data => {
      this.saleOrganizationList = data;

      //console.log("SaleOrganization List : " + JSON.stringify(this.saleOrganizationList));

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].AssignFlag == 'Y') {
          this.hidebutton = false;
          this.assignflag = false;
        }
        else {
          this.hidebutton = true;
          this.assignflag = true;
        }
      }
      else {
        this.hidebutton = true;
        this.assignflag = true;
      }

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].ViewFlag == 'Y') {
          this.viewflag = true;
        }
        else {
          this.viewflag = false;
        }
      }
      else {
        this.viewflag = false;
      }

      if (this.saleOrganizationList.length > 0) {
        this.saleorglevelemplogin = this.saleOrganizationList[0].Levels
      }
      else {
        this.saleorglevelemplogin = 1;
      }

      this.LoadProjectSale();
    }).then(() => {
      this.LoadSaleOrganizationLevelmax();

    });
  }

  async LoadSaleOrganizationLevelList(): Promise<SaleOrganizationInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EmpCode'] = this.checkUndefinedString(this.empcodeinit);

      let strjson = JSON.stringify(objectjson);

      this.saleOrganizationPromise = this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
        .toPromise()

      return this.saleOrganizationPromise;
    }
  }

  async LoadSaleOrganizationLevelmax() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
        .toPromise().then(
          data => {
            this.saleOrganizationMaxList = data;
            this.saleOrganizationMaxList = this.saleOrganizationMaxList.sort((a, b) => a.Levels - b.Levels);

            if (this.saleOrganizationMaxList.length > 0) {
              this.saleorglevelmax = this.saleOrganizationMaxList[this.saleOrganizationMaxList.length - 1].Levels;

            }
            else {
              this.saleorglevelmax = 1;
            }
          })
    }
  }


  ConvertFormArrayToJson(objectFormArray: FormArray): string {
    var objectarray = [];
    $.each(objectFormArray.controls, function (index, value) {
      objectarray.push(value.value);
    });

    return JSON.stringify(objectarray);

  }

  // Function Update variable abount pagination
  LoadProjectSaleUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;

  }

  //Lead group
  //function Update Group projectsale
  //1. Get list project group to modal
  //2. Send list projs id to save 
  //Variables
  listProjGroup: RoleInfo[] = [];
  totalProjectGroup: number;
  totalPage_ProjectGroup: number;
  currentPageNumber_ProjectGroup: number;

  async LoadListProjectGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<RoleInfo[]>(this.baseurl + "Role/GetRole",
          strjson, httpOptions)
        .subscribe(data => {
          this.listProjGroup = data;
        });
    }
  }

  async LoadCountProjectGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<number>(this.baseurl + "Master/GetCountProjectGroup",
          strjson, httpOptions)
        .subscribe(data => {

          this.currentPageNumber_ProjectGroup = 1;
          this.totalProjectGroup = data;//จำนวน data ทั้งหมด

          if(this.totalProjectGroup == 0){
            this.currentPageNumber_ProjectGroup = 0;
          }

          this.totalPage_ProjectGroup = Math.ceil(this.totalProjectGroup / environment.PageSize);//จำนวนที่แบ่ง page ได้
        });
    }
  }

  OnLoadProjGroupFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_ProjectGroup = traget.currentPageNumber;
      this.totalPage_ProjectGroup = traget.totalPages;
    }

    this.LoadListProjectGroup();
  }
  OnBtnOpenProjectGroupModalClick() {
    $('#ModalProjectGroup').modal();
  }

  get isFlagAssignSaleTeamChecked(): boolean {
    return this.form.get('FlagAssignSaleTeam').value === 'Y';
  }

  set isFlagAssignSaleTeamChecked(value: boolean) {
    this.form.patchValue({
      FlagAssignSaleTeam: value ? 'Y' : 'N'
    });
  }

  async updateFlagAssignSaleTeam(roleId: number, checked: boolean) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) return;

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const payload = {
        RoleId: roleId,
        FlagAssignSaleTeam: checked ? 'Y' : 'N'
      };

      const strjson = JSON.stringify(payload);

      await this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/UpdateRole", strjson, httpOptions)
        .toPromise();

      // Update the local RoleList
      const index = this.RoleList.findIndex(item => item.RoleId === roleId);
      if (index !== -1) {
        this.RoleList[index].FlagAssignSaleTeam = checked ? 'Y' : 'N';
      }
    } catch (error) {
      console.error('Error updating FlagAssignSaleTeam:', error);
    }
  }
}
